export const environment = {
  production: false,
  apiUrl: 'https://api-paramount.dottesting.com',
  firebase: {
    apiKey: 'AIzaSyCY6-M3dY5yPvzeXZhH_0sLdcbouXgxsqI',
    authDomain: 'paramount-app-dev.firebaseapp.com',
    projectId: 'paramount-app-dev',
    storageBucket: 'paramount-app-dev.firebasestorage.app',
    messagingSenderId: '1007578219697',
    appId: '1:1007578219697:web:7a996d0fc210a5fb09ce90',
    vapidKey: 'BI9lnGX6TAbXDB-zEMoOkrf-lEq6QIXLHu0Ghhwi_IflRWfs3_fnyqGBdZBBO7pHa9bNHPimJCdAuXCl-axmSdg',
  },
};
